export const prepareFilters = (value) => {
  const params = {}
  for (const key in value)
    params[key] = Array.isArray(value[key])
      ? value[key].map((item) => item.id)
      : value[key]

  return params
}

export const scrollTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

export const scrollTo = (element, options) =>
  element.scrollIntoView({ behavior: 'smooth', ...options })

export const formatPrice = ({ price, currency }) =>
  parseFloat(price) + ' ' + (currency ? currency.toLowerCase() : 'lei')

export const isEmpty = (obj) => {
  return obj ? Object.keys(obj).length === 0 : true
}

export const pluralize = (count, singular, plural) => {
  return count === 1 ? singular : plural
}
